import React from 'react'
import { asCurrency } from '@ally/aos-utils'
import { Box, TextBody, Space } from '@ally/metronome-ui'
import { useAccountTypes } from '../AccountTypeContext'
import TotalBalanceDejarg from '../CustomizeDashboard/Widgets/AccountsOverviewWidget/TotalBalanceDejarg'

const TotalBalance = (): JSX.Element => {
  const { totalBalance } = useAccountTypes()
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      <TextBody tag="p" size="xl" weight="bold">
        {asCurrency(totalBalance.toString())}
      </TextBody>
      <Space mt="xs" mb="sm">
        <Box display="flex" alignItems="center">
          <TotalBalanceDejarg />
          <Box display="inline-block">
            <TextBody tag="p" size="sm">
              &nbsp;Total
            </TextBody>
          </Box>
        </Box>
      </Space>
    </Box>
  )
}

export default TotalBalance
